import React from 'react';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'css/carousel.css';

import PlaceholderImage from 'assets/logo_full.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { hintTypeDescription, setQueryHyperlink } from 'components/lotto/utility/Utility.js';

const LottoHintCarousel = ({ hintDataArray, hintInsightDataArray, slug }) => {
  if (!hintDataArray?.length) return null;

  return (
    <div className="hint-carousel">
      <Carousel
        autoPlay
        interval={5000}
        variant="dark"
        touch
        indicators
        className="hint-carousel__track"
      >
        {hintDataArray.map((a, i) => {
          const matchingInsight = hintInsightDataArray?.find(
            (insight) => insight.hintType === a.hintType
          );

          return (
            <Carousel.Item key={i}>
              <article className="hint-card">
                <header className="hint-card__header">
                  <h3 className="hint-card__title">
                    {hintTypeDescription(a.hintType)}
                  </h3>
                  {matchingInsight?.hintType && (
                    <dl className="hint-card__stats">
                      <div className="hint-card__stat">
                        <dt>สองตัวล่าง</dt>
                        <dd>{matchingInsight.percentHintMatchDown2Prize}%</dd>
                      </div>
                      <div className="hint-card__stat">
                        <dt>สองตัวบน</dt>
                        <dd>{matchingInsight.percentHintMatchFinalPrizeLast2Digits}%</dd>
                      </div>
                    </dl>
                  )}
                </header>

                <div className="hint-card__image-wrap">
                  <LazyLoadImage
                    id={a.hintType}
                    src={a.hintImgUrl}
                    className="hint-card__image"
                    alt={hintTypeDescription(a.hintType)}
                    title={hintTypeDescription(a.hintType)}
                    placeholdersrc={PlaceholderImage}
                    effect="blur"
                  />
                </div>

                <div className="hint-card__numbers">
                  <span className="hint-card__numbers-label">เลขเด็ด</span>
                  {setQueryHyperlink(a.hintNumbers, slug)}
                </div>
              </article>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </div>
  );
};

export default LottoHintCarousel;
